var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('top-bar',{staticStyle:{"height":"60px"},attrs:{"is-transparent":_vm.isTopBarTransparent}}),_c('router-view',{staticClass:"main-content"}),_c('bottom-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }